export default "__VITE_ASSET__BHDWP0$K__"